import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { environment } from 'src/environments/environment';
import { SubDomainService } from 'src/app/core/services/sub-domain.service';
import {
  BehaviorSubject,
  Observable,
  Subject,
  debounceTime,
  mergeMapTo,
} from 'rxjs';
import { Location } from '@angular/common';
import { AutoComplete } from 'primeng/autocomplete';
import { UpdateAvatarService } from 'src/app/core/services/update-avatar.service';
import { ProgressBarUpdatesService } from 'src/app/core/services/progress-bar-updates.service';
import { ThirdPartiesService } from 'src/app/modules/third-parties/third-parties.service';
import { IconName } from '../app-icon/icon.registry';
import {
  getMessaging,
  getToken,
  onMessage,
  Messaging,
} from '@angular/fire/messaging';
import { FirebaseApp } from '@angular/fire/app';
import { ChatsService } from 'src/app/core/services/chats.service';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBarComponent implements OnInit {
  notificationShow: boolean = false;
  isMainDomain: boolean = false;
  domain: any = environment.domain;
  @Input('header') header!: string | null;
  @Input('leftArrowRoute') leftArrowRoute!: string | null;
  @Input('titleStyle') titleStyle: any;
  @Input('isCircle') isCircle: boolean = false;
  @Input('searchEnable') searchEnable: boolean = true;
  // @Input('searchbar') searchbar: any;
  selectModule: any;
  @Input('placeholderValue') placeholderValue: string =
    'Select Module To Search';
  suggestions: any[] = [];
  moduleData: any = [];
  modules: any;
  fieldValue: string = '';
  showConfirmMessage: boolean = false;
  loading: boolean = false;
  isLoadingNotify: boolean = false;
  loadingSubmit: boolean = false;
  prefixEndpoint: any;
  // search
  public model: any;
  searchInput = new BehaviorSubject('');
  searchKeyword = '';
  filterParams: any = {};
  searchEnabled: boolean = false;
  @ViewChild('messageComponent', { static: false }) componentMessage: any;
  // @ViewChild('searchName', {static: false}) searchName:any;
  @ViewChild('searchName') autoComplete!: AutoComplete; // Access the template reference variable of p-autoComplete

  userObj: any = this._auth.getUserObj();
  avatar: any = this.userObj?.avatar;
  isGhostSession: boolean = false;
  ghostUserName: string = '';

  @ViewChild('exitGhostConfirmComponent', { static: false })
  exitGhostConfirmComponent: any;

  private _messaging = inject(Messaging);
  private messageSource: Subject<any> = new Subject<any>();
  messagesList: any[] = [];
  loadingSchema: any[] = ['', '', '', '', '', ''];
  hasNewMessageReceived: boolean = false;
  numberOfUnreadMessages: number = 0;
  showNotificationBanner: boolean = true;

  constructor(
    private _api: HttpService,
    private _auth: AuthService,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private subdomainService: SubDomainService,
    private location: Location,
    private avatarService: UpdateAvatarService,
    private _ProgressService: ProgressBarUpdatesService,
    private thirdPartiesService: ThirdPartiesService,
    private _chatService: ChatsService,
    private ofApp: FirebaseApp,
    private cdr: ChangeDetectorRef,
  ) {}

  exitGhostSession(): void {
    this.exitGhostConfirmComponent.open();
  }

  confirmExitGhostSession(): void {
    this.exitGhostConfirmComponent.close();
    
    // Restore main session and get the backed up URL
    const backupUrl = this._auth.restoreMainSession();

    // Set session switching flag to show loader
    this._auth.setSessionSwitching(true);

    this.notificationService.success('Success', 'Returning to main session...');
    
    // Reload the page to the original URL or dashboard as fallback
    setTimeout(() => {
      window.location.href = backupUrl || '/dashboard';
    }, 500);
  }

  ngOnInit(): void {
    // Check if in ghost session
    this.isGhostSession = this._auth.isGhostSession();
    if (this.isGhostSession && this.userObj) {
      this.ghostUserName = `${this.userObj.first_name || ''} ${this.userObj.last_name || ''}`.trim();
    }

    if (this.subdomainService.getUpdatedActiveSubdomain()) {
      this.prefixEndpoint = '/auth/';
    } else {
      this.prefixEndpoint = '/';
    }

    if (this.subdomainService.getUpdatedActiveSubdomain()) {
      this.isMainDomain = false;
    } else {
      this.isMainDomain = true;
    }

    this.avatarService.getUpdatedAvatarObservable().subscribe((res) => {
      this.avatar = res;
      this.cdr.markForCheck();
    });

    this.modules = [
      { name: 'Third Parties', key: 'third-parties' },
      { name: 'Products', key: 'products' },
      { name: 'Contracts', key: 'contracts' },
      { name: 'Vehicles', key: 'vehicles' },
      { name: 'Claims', key: 'claims' },
      { name: 'Brokers', key: 'users?filter_by_group=3' },
      { name: 'Agents', key: 'users?filter_by_group=2' },
      { name: 'Dealers', key: 'users?filter_by_group=5' },
      { name: 'Producers', key: 'users?filter_by_group=4' },
    ];

    this.activeRoute.queryParams.subscribe((params) => {
      this.searchKeyword = params['global_search'];
      if (this.selectModule?.key && this.searchKeyword) {
        this.getModuleData();
      }
    });

    // when initial component invoke function to list all unread messages from db not firebase
    this.hasNewMessageReceived = true;
    if (!this.isMainDomain) {
      if (this._chatService.notificationsList.length) {
        this.messagesList = this._chatService.notificationsList;
        this.numberOfUnreadMessages = this.messagesList.length;
      } else {
        this.getAllUnreadMessages();
      }
      this.requestPermission();
      this.listen();
    }
    // listen to firebase to get new messages
    this.messageSource.subscribe((message: any) => {
      if (message?.time) {
        this.hasNewMessageReceived = true;
        this.numberOfUnreadMessages = this.numberOfUnreadMessages + 1;
        this.messagesList.unshift(message);
        this.cdr.markForCheck();
      }
    });
  }

  notificationDetails(notification: any) {
    switch (notification?.type) {
      case 'ChangeRequestNotification':
        this.router.navigate([
          `/dashboard/change-request-list/${notification?.notification_data?.user_id}`,
        ]);
        break;
      case 'AutomaticSystemNotification':
        if (
          notification?.notification_data &&
          notification?.notification_data?.model === 'claim'
        ) {
          this.router.navigate([
            `/dashboard/claims/claim-details/${notification?.notification_data?.id}`,
          ]);
        }
        break;
      case 'NewDealerCreatedNotification':
        if (
          notification?.notification_data &&
          notification?.notification_data?.user_id
        ) {
          this.router.navigate([
            `/dashboard/clients/dealer-details/${notification?.notification_data?.user_id}/info`,
          ]);
        }
        break;
      case 'ClaimReminderNotification':
        this.router.navigate([
          `/dashboard/claims/claim-details/${notification?.notification_data?.claim_id}`,
        ]);
        break;
      case 'FormSendNotification':
        if (notification?.notification_data?.user_type === 'Brokers') {
          this.router.navigate([
            `/dashboard/clients/broker-details/${notification?.notification_data?.user_id}/info`,
          ]);
        }
        break;
      case 'NoteMentionNotification':
        this.handleNoteMentionNavigation(notification?.notification_data);
        break;
      default: {
        if (
          notification.notification_data?.model === 'claim' ||
          notification.notification_data?.claim_id
        ) {
          this.router.navigate([
            `/dashboard/claims/claim-details/${
              notification?.notification_data?.id ||
              notification?.notification_data?.claim_id
            }`,
          ]);
        }
      }
    }
  }

  private handleNoteMentionNavigation(notificationData: any): void {
    if (!notificationData) {
      return;
    }

    const { type, id } = notificationData;

    switch (type) {
      case 'Contract':
        this.router.navigate([
          `/dashboard/contracts/contract-details/${id}/claim-notes`,
        ]);
        break;
      case 'Claim':
        this.router.navigate([
          `/dashboard/claims/claim-details/${id}/notes`,
        ]);
        break;
      case 'Product':
        this.router.navigate([
          `/dashboard/products/product-details/${id}/notes`,
        ]);
        break;
      default:
        // Fallback to notification center
        this.router.navigate(['/dashboard/notifications/all']);
    }
  }

  listen() {
    onMessage(this._messaging, (payload) => {
      let newMessage: any = payload?.notification;
      newMessage['time'] = 'new';
      this.messageSource.next(newMessage);
    });
  }

  requestPermission() {
    // const messaging = getMessaging(this.ofApp);
    getToken(this._messaging, { vapidKey: environment.vpaidKey }).then(
      (currentToken) => {
        if (currentToken) {
          let oldToken = this._auth.getCookie('notificationToken');
          if (oldToken != currentToken) {
            this.saveToken(currentToken);
          }
        }
      }
    );
  }

  saveToken(token: any) {
    let payload: any = {
      token: token,
    };
    this._api.postReq('/fcm-tokens', payload).subscribe(
      (res) => {
        // save token on cookies
        this._auth.setCookie('notificationToken', token, 30);
      },
      (err) => {
        this.errHandle.errorHandling(err);
      }
    );
  }

  backRoute() {
    if (this.leftArrowRoute == 'back') {
      this.location.back();
    } else {
      this.router.navigate([this.leftArrowRoute]);
    }
  }
  goToNotifyPage() {
    this.router.navigate(['/dashboard/notifications/all']);
  }
  goToSettingsNotify() {
    this.router.navigate(['/dashboard/my-account/notifications']);
  }
  showProfileMenu() {
    document
      .querySelector('.account-info .account-info-tab')
      ?.classList.add('show');
    document.querySelector('.overlay-navbar')?.classList.add('show');
    window.scrollTo(0, 0);
    // document.body.style.overflow = 'hidden';
  }

  closeProfileMenu() {
    document
      .querySelector('.account-info .account-info-tab')
      ?.classList.remove('show');
    document.querySelector('.overlay-navbar')?.classList.remove('show');
    // document.body.style.overflow = 'auto';
  }

  openConfirm() {
    this.componentMessage.open();
  }

  accepted() {
    this.signOut();
  }

  rejected() {
    // this.showConfirmMessage = false;
    this.closeProfileMenu();
    this.componentMessage.close();
  }

  signOut() {
    this.loadingSubmit = true;
    this._api.getReq(`${this.prefixEndpoint}logout`).subscribe(
      (res) => {
        this.showConfirmMessage = false;
        this.componentMessage.close();
        this.closeProfileMenu();
        this._auth.signOut();
        this.notificationService.success('', res.message);
        this.loadingSubmit = false;
        this.cdr.markForCheck();
      },
      (err) => {
        this.showConfirmMessage = false;
        this.closeProfileMenu();
        this.errHandle.errorHandling(err);
        this.loadingSubmit = false;
        this.cdr.markForCheck();
      }
    );
  }

  goToMyAccount() {
    this.closeProfileMenu();
    this.router.navigate(['/dashboard/my-account']);
  }

  // Handle globle searching for modules [Third Parties,Vehicles,Products,Contracts,Claims,Brokers,Agents,Dealers,Producers]
  search(event: any) {
    this.searchKeyword = event?.query?.toLowerCase();
    this.searchInput.next(this.searchKeyword);
    this.searchInput.pipe(debounceTime(1000)).subscribe((value: String) => {
      if (this.searchKeyword?.length > 1 || this.searchKeyword?.length == 0) {
        if (this.searchKeyword) {
          this.filterParams['global_search'] = this.searchKeyword;
        } else {
          delete this.filterParams['global_search'];
        }
        this.router.navigate([], { queryParams: this.filterParams });
      }
    });
  }
  getModuleName(e: any) {
    this.searchEnabled = true;
    const module: any = {};
    module['name'] = e?.value?.name;
    module['key'] = e?.value?.key;
    this.selectModule = module;
    this.autoComplete.inputEL.nativeElement.value = '';
    this.setModulePlaceholder();
    //
  }

  getModuleData() {
    if (this.selectModule?.key === 'claims') {
      this.selectModule['key'] = 'claim';
    }

    this._api
      .getReq(`/${this.selectModule?.key}?global_search=${this.searchKeyword}`)
      .subscribe(
        (res) => {
          this.setModuleField();
          this.moduleData = res?.data;
          if (this.selectModule?.name === 'Vehicles') {
            this.moduleData = this.moduleData.map((data: any) => ({
              id: data?.id,
              brand_vin: data?.trim?.model?.brand?.name + ' | ' + data?.vin,
            }));
          } else if (this.selectModule?.name === 'Contracts') {
            this.moduleData = this.moduleData.map((data: any) => ({
              id: data?.id,
              contractType_contractNumber:
                data?.type?.name + ' | ' + data?.reference_code,
            }));
          } else if (this.selectModule?.name === 'Claims') {
            this.moduleData = this.moduleData.map((data: any) => ({
              id: data?.id,
              claimAdjustor_email:
                data?.adjustor?.first_name +
                ' ' +
                data?.adjustor?.last_name +
                ' | ' +
                data?.adjustor?.email,
            }));
          } else if (
            this.selectModule?.name === 'Brokers' ||
            this.selectModule?.name === 'Agents' ||
            this.selectModule?.name === 'Dealers' ||
            this.selectModule?.name === 'Producers'
          ) {
            this.moduleData = this.moduleData.map((data: any) => ({
              id: data?.id,
              name_email:
                data?.first_name + ' ' + data?.last_name + ' | ' + data?.email,
            }));
          }
          //
          //
          this.suggestions = this.moduleData.filter((item: any) =>
            item[this.fieldValue]?.toLowerCase()?.includes(this.searchKeyword)
          );
          if (this.suggestions.length === 0) {
            this.suggestions = [
              { [this.fieldValue]: 'No matching suggestions' },
            ];
          }
          this.cdr.markForCheck();
        },
        (err) => {
          this.errHandle.errorHandling(err);
          this.cdr.markForCheck();
        }
      );
  }

  onSuggestionSelect(event: any) {
    const selectedItem = event;
    if (selectedItem) {
      this.handleNavigation(selectedItem);
      //
    }
  }

  setModulePlaceholder() {
    switch (this.selectModule?.name) {
      case 'Third Parties':
        this.placeholderValue = 'Search By Third Party Name';
        break;
      case 'Vehicles':
        this.placeholderValue = 'Search by Brand';
        break;
      case 'Products':
        this.placeholderValue = 'Search By Product Name';
        break;
      case 'Contracts':
        this.placeholderValue = 'Search By Contract Type';
        break;
      case 'Claims':
        this.placeholderValue = 'Search By Claim Adjuster';
        break;
      case 'Brokers':
        this.placeholderValue = 'Search By Broker Name';
        break;
      case 'Agents':
        this.placeholderValue = 'Search By Agent Name';
        break;
      case 'Dealers':
        this.placeholderValue = 'Search By dealer Name';
        break;
      case 'Producers':
        this.placeholderValue = 'Search By Producer Name';
        break;
      default:
        this.placeholderValue = 'Select Module To Search';
    }
  }
  setModuleField() {
    switch (this.selectModule?.name) {
      case 'Third Parties':
        this.fieldValue = 'name';
        break;
      case 'Vehicles':
        this.fieldValue = 'brand_vin';
        break;
      case 'Products':
        this.fieldValue = 'label';
        break;
      case 'Contracts':
        this.fieldValue = 'contractType_contractNumber';
        break;
      case 'Claims':
        this.fieldValue = 'claimAdjustor_email';
        break;
      case 'Brokers':
      case 'Agents':
      case 'Dealers':
      case 'Producers':
        this.fieldValue = 'name_email';
        break;
    }
  }

  handleNavigation(selectedItem: any) {
    if (selectedItem) {
      let id = selectedItem?.id;
      switch (this.selectModule?.name) {
        case 'Third Parties':
          this.router.navigate([
            `./dashboard/third-parties/third-parties-list`,
          ]);
          setTimeout(() => {
            this.thirdPartiesService.openDialog(selectedItem);
          }, 0);
          break;
        case 'Vehicles':
          this.router.navigate([`./dashboard/vehicles/details/${id}`]);
          break;
        case 'Products':
          this.router.navigate([`./dashboard/products/product-details/${id}`]);
          break;
        case 'Contracts':
          this.router.navigate([
            `./dashboard/contracts/contract-details/${id}/contract-information`,
          ]);
          break;
        case 'Claims':
          this.router.navigate([`./dashboard/claims/claim-details/${id}`]);
          break;
        case 'Brokers':
          this.router.navigate([`./dashboard/clients/broker-details/${id}`]);
          break;
        case 'Agents':
          this.router.navigate([`./dashboard/clients/agent-details/${id}`]);
          break;
        case 'Dealers':
          this.router.navigate([`./dashboard/clients/dealer-details/${id}`]);
          break;
        case 'Producers':
          this.router.navigate([`./dashboard/clients/producer-details/${id}`]);
      }
    }
  }

  openNotifyPopup() {
    this.notificationShow = !this.notificationShow;
    if (!this.hasNewMessageReceived) {
      this.getAllUnreadMessages();
    }
  }

  getAllUnreadMessages() {
    this.isLoadingNotify = true;
    this._api.getReq('/notifications?all=0').subscribe(
      (res) => {
        this.isLoadingNotify = false;
        this.messagesList = res?.data ? res?.data : [];
        this._chatService.notificationsList = this.messagesList;
        this.numberOfUnreadMessages = this.messagesList.length;
        this.cdr.markForCheck();
      },
      (err) => {
        this.errHandle.errorHandling(err);
        this.isLoadingNotify = false;
        this.cdr.markForCheck();
      }
    );
  }

  makeAllAsRead() {
    if (this.loadingSubmit) {
      return;
    }
    this.loadingSubmit = true;
    this._api.postReq('/notifications/read').subscribe(
      (res) => {
        this.loadingSubmit = false;
        this.messagesList = [];
        this.numberOfUnreadMessages = 0;
        this.cdr.markForCheck();
      },
      (err) => {
        this.errHandle.errorHandling(err);
        this.loadingSubmit = false;
        this.cdr.markForCheck();
      }
    );
  }

  dismissNotificationBanner() {
    this.showNotificationBanner = false;
  }

  getUnreadCountLabel(): string {
    return this.numberOfUnreadMessages > 99
      ? '99+'
      : this.numberOfUnreadMessages.toString();
  }

  getNotificationTitle(notification: any): string {
    return notification?.title || 'Notification';
  }

  getNotificationTime(notification: any): string {
    return notification?.time === 'new' ? 'New' : notification?.time || '';
  }

  getNotificationReference(notification: any): string {
    const data = notification?.notification_data || {};
    return (
      data?.claim_number ||
      data?.contract_number ||
      data?.reference_code ||
      data?.code ||
      data?.id ||
      ''
    );
  }

  getNotificationTone(notification: any): 'done' | 'activity' | 'payment' {
    const title = `${notification?.title || ''}`.toLowerCase();
    const body = `${notification?.body || ''}`.toLowerCase();
    const type = `${notification?.type || ''}`.toLowerCase();
    const text = `${title} ${body} ${type}`;

    if (text.includes('payment') || text.includes('paid')) {
      return 'payment';
    }

    if (text.includes('complete') || text.includes('completed')) {
      return 'done';
    }

    return 'activity';
  }

  getNotificationIcon(notification: any): IconName {
    const tone = this.getNotificationTone(notification);

    if (tone === 'payment') {
      return 'credit-card';
    }

    if (tone === 'done') {
      return 'check';
    }

    return 'bolt';
  }
}
